exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3homNQyQW4CylXHvXOHOp7{background-color:#fff;-webkit-box-shadow:0px 6px 13px 0px rgba(200,200,200,0.75);box-shadow:0px 6px 13px 0px rgba(200,200,200,0.75);font-size:1.5rem}\n", ""]);

// exports
exports.locals = {
	"customButton": "_3homNQyQW4CylXHvXOHOp7"
};